import * as React from 'react';
import { Divider } from '@material-ui/core';
import { List } from '@material-ui/core';
import { ListSubheader } from '@material-ui/core';
import { ListItem } from '@material-ui/core';
import { ListItemText } from '@material-ui/core';
import { ListItemIcon } from '@material-ui/core';
import { Ballot as BallotIcon } from '@material-ui/icons';
import { Assessment as AssessmentIcon } from '@material-ui/icons';
import { List as ListIcon } from '@material-ui/icons';
import { People as PeopleIcon } from '@material-ui/icons';
import { withStyles, StyleRulesCallback, WithStyles } from '@material-ui/core/styles';
import { RouteComponentProps, withRouter } from 'react-router';
import { translation } from '../i18n';
import { observer } from 'mobx-react';
import { logout } from '../security/keycloak';
import { EmployeeDto } from '../pages/user/userTypes';
import { IObservableValue } from 'mobx';
import { MenuIcons, MenuItem, MenuList, MenuType } from './menuTypes';

type LocalStyles = 'toolbar' | 'accountSection' | 'listItem';

interface Props {
  selfAccount: EmployeeDto,
  currentRouteIndex: IObservableValue<number>;
  resetSearch: () => void;
  handleDrawerToggle: () => void;
  mobileOpen: boolean;
}

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  toolbar: theme.mixins.toolbar,
  accountSection: {
    marginLeft: theme.spacing.unit * 2,
    margin: theme.spacing.unit,
  },
  listItem: {
    backgroundColor: '#FFF'
  }

});

type PropsWithStyle = WithStyles<LocalStyles> & RouteComponentProps & Props;

@observer
class DrawerMenu extends React.Component<PropsWithStyle> {

  constructor(props: PropsWithStyle) {
    super(props);
    this.routeTo = this.routeTo.bind(this);
  }

  public render() {

    const {classes} = this.props;

    return (
      <div>
        <div className={classes.toolbar}>
          <div className={classes.accountSection}>
            <p>{this.props.selfAccount.firstName} {this.props.selfAccount.lastName}</p>
          </div>
        </div>
        <Divider/>
        <List>
          {
            MenuList(this.props.selfAccount).map( (menuItem, index) => (
              this.renderMenuItem(menuItem, index, classes.listItem)
            ))
          }
          <ListItem button={true}>
            <ListItemText primary={translation.t('menu.logout')} onClick={() => {
              logout();
            }}/>
          </ListItem>
        </List>
      </div>
    );
  }

  private renderMenuItem(item: MenuItem, index: number, className: string) {
    switch (item.type) {
      case MenuType.DIVIDER: {
        return (<Divider key={index}/>)
      }
      case MenuType.ITEM: {
        return this.renderItem(item, index, className)
      }
      case MenuType.HEADER: {
        return <ListSubheader key={index} className={className}>{item.text}</ListSubheader>
      }
    }
  }

  private renderItem(item: MenuItem, index: number, className: string) {
    return <ListItem className={className} button={true} key={index}
                     selected={this.props.currentRouteIndex.get() === item.routeWithIndex!!.index}>
      {item.icon &&
      this.renderIcon(item)
      }
      <ListItemText primary={item.text}
                    onClick={() => this.routeTo(item.routeWithIndex!!.route)}/>
    </ListItem>
  }

  private renderIcon(item: MenuItem) {
    switch (item.icon) {
      case MenuIcons.ASSESSMENT: {
        return (
          <ListItemIcon>
            <AssessmentIcon/>
          </ListItemIcon>
        )
      }
      case MenuIcons.LIST: {
        return (
          <ListItemIcon>
            <ListIcon/>
          </ListItemIcon>
        )
      }
      case MenuIcons.BALLOT: {
        return (
          <ListItemIcon>
            <BallotIcon/>
          </ListItemIcon>
        )
      }
      case MenuIcons.PEOPLE: {
        return (
          <ListItemIcon>
            <PeopleIcon/>
          </ListItemIcon>
        )
      }
      default: {
        return (<></>)
      }
    }
  }

  private routeTo(path: string) {
    this.props.history.push(path);
    this.props.resetSearch();
    if (this.props.mobileOpen) {
      this.props.handleDrawerToggle()
    }
  }

}

export default withRouter(withStyles(localStyles, {withTheme: true})(DrawerMenu));
